var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3334C13.4517 18.3334 16.25 15.5352 16.25 12.0834C16.25 11.2501 16.25 9.58342 14.5833 7.50008C14.5833 7.50008 14.5003 9.87808 12.8552 9.53408C10.1942 8.97775 13.6292 3.75255 8.75 1.66675C8.75 5.83341 3.75 7.08341 3.75 12.0834C3.75 15.5352 6.54822 18.3334 10 18.3334Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 15.8343C11.6109 15.8343 12.9167 14.1554 12.9167 12.0843C10.25 13.0843 9.30562 10.7817 9.16671 9.16675C7.96192 9.62775 7.08337 11.5214 7.08337 12.5001C7.08337 14.5712 8.38921 15.8343 10 15.8343Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMark);
export default __webpack_public_path__ + "static/media/mark.b29f5bc4fbc2a36c14b8ee8582dc5832.svg";
export { ForwardRef as ReactComponent };